<template>
  <v-card class="my-6 pa-6">
    Featured Creators
  </v-card>
</template>

<script>
export default {
  name: 'FeaturedCreators',
}
</script>

<style lang="scss" scoped>
</style>